import { e as error } from "../../../../../../chunks/index.js";
const get_employee_documents = async (event) => {
  try {
    let employeeResponse = await event.fetch(`$api/employee/${event.params.uuid}/documents`, {
      method: "GET",
      headers: event.locals.fetchAuthHeaders
    });
    if (employeeResponse.ok) {
      return await employeeResponse.json();
    }
  } catch (e) {
    console.error("Error fetching employee", e);
  }
  error(500, "Error fetching employee");
};
const load = async (event) => {
  return {
    documents: await get_employee_documents(event)
  };
};
export {
  load
};
//# sourceMappingURL=_page.server.ts.js.map
